const workflowsActionTypes = {
  SET_WORKFLOWS: 'SET_WORKFLOWS',
  ADD_WORKFLOW: 'ADD_WORKFLOW',
  UPDATE_WORKFLOW: 'UPDATE_WORKFLOW',
  REMOVE_WORKFLOW: 'REMOVE_WORKFLOW',
};
export default workflowsActionTypes;
